import { useContext } from 'react'
import SurveyContext from '../SurveyContext';

export const useSurveyContext = () => {
    return useContext(SurveyContext);
}
